export default "__VITE_ASSET__Ckper_jU__"